import React, { Fragment, useMemo } from 'react';

import { Menu, Select } from 'antd';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import chinese from 'assets/icons/languages/china.png';
import cambodia from 'assets/icons/languages/combodia.png';
import english from 'assets/icons/languages/english.png';
import french from 'assets/icons/languages/france.png';
import russia from 'assets/icons/languages/russia.png';
import spanish from 'assets/icons/languages/spain.png';
import thai from 'assets/icons/languages/thai.png';
import turkey from 'assets/icons/languages/turkey.png';
import { IMG_ALT, KEY_LANGUAGE_LOCALSTORAGE } from 'consts/app';
import { getLanguageKey } from 'hooks/useMultiLanguage';
import useThemes from 'hooks/useThemes';
import { LanguageEnum, changeLanguage } from 'redux/userSlice';
import { getLocalStorage, setLocalStorage } from 'utils/sessionStorage';
import { MenuType } from './AccountSubMenu';

interface SettingMenuProps {}

const SettingSubMenu = (props: SettingMenuProps) => {
  const t = useAppTranslation();

  const settingMenu: MenuType[] = [
    {
      title: (
        <a href="mailto:support@terabet.io" className="header-icon cursor-pointer">
          {t('footerMenu.support')}
        </a>
      ),
    },
    {
      title: <LanguageDropdown />,
    },
  ];
  return (
    <Fragment>
      <Menu className="menuSetting" triggerSubMenuAction={'click'}>
        {settingMenu.map((item, idx) => (
          <Menu.Item
            key={`account-sub-menu-${idx}`}
            className="drop-down-item"
            onClick={item.onClick}
          >
            {item.title}
          </Menu.Item>
        ))}
      </Menu>
    </Fragment>
  );
};

export default SettingSubMenu;

const { Option } = Select;

interface LanguageDropdownProps {}

const LanguageDropdown: React.FunctionComponent<LanguageDropdownProps> = () => {
  const dispatch = useAppDispatch();

  const defaultLanguage = useMemo(() => {
    return getLanguageKey(getLocalStorage(KEY_LANGUAGE_LOCALSTORAGE) || '');
  }, []);

  const handleChangeLanguage = (value: LanguageEnum) => {
    dispatch(changeLanguage(value));
    setLocalStorage(KEY_LANGUAGE_LOCALSTORAGE, value);
  };

  const languages = [
    { value: LanguageEnum.ENGLISH, label: 'Language', localLabel: 'English', image: english },
    { value: LanguageEnum.CHINESE, label: '语言', localLabel: '中文', image: chinese },
    { value: LanguageEnum.FRENCH, label: 'Langue', localLabel: 'Français', image: french },
    { value: LanguageEnum.SPANISH, label: 'Idioma', localLabel: 'Español', image: spanish },
    { value: LanguageEnum.THAI, label: 'ภาษา', localLabel: 'ไทย', image: thai },
    { value: LanguageEnum.CAMBODIA, label: 'ភាសា', localLabel: 'ខ្មែរ', image: cambodia },
    { value: LanguageEnum.TURKEY, label: 'Dil', localLabel: 'Türkçe', image: turkey },
    { value: LanguageEnum.RUSSIA, label: 'язык', localLabel: 'Русский', image: russia },
  ];

  const renderLabel = (img: string, label: string) => (
    <div className="flex-row items-center gap-1 p-1">
      <img className="w-5 h-5" src={img} alt={IMG_ALT} />
      <span>{label}</span>
    </div>
  );

  return (
    <Select
      className="languages-selected primary-text-color"
      dropdownClassName="language-items primary-text-color"
      defaultValue={defaultLanguage}
      onChange={handleChangeLanguage}
      optionLabelProp="label"
      placement="bottomRight"
    >
      {languages.map(({ value, label, image, localLabel }) => (
        <Option key={value} value={value} label={label}>
          {renderLabel(image, localLabel)}
        </Option>
      ))}
    </Select>
  );
};
